import React, {useCallback} from 'react';
import _debounce from 'lodash/debounce';
import './searchBox.scss';

const SearchBox = ({placeholder, setQuery}) => {
  const onChange = useCallback(
    _debounce((e) => {
      setQuery(e);
    }, 300),
    []
  );

  return (
    <div className="search-box">
      <input
        placeholder={placeholder}
        type="text"
        onChange={(e) => onChange(e.target.value)}
        className="form-control"
      />
    </div>
  );
};

export default SearchBox;
